import React from "react";
import { useIsMobile } from "../../../../Hooks";

import useStyles from "./FmCalculatedNpkCard.style";
import { nutrients, ZERO } from "../../../../Utils/Consts";
import { useTranslation } from "react-i18next";
interface FmCalculatedNpkCardProps {
    n: number | null;
    p: number | null;
    k: number | null;
    missingPercentage?: number | null;
}

const FmCalculatedNpkCard = ({ n, p, k, missingPercentage }: FmCalculatedNpkCardProps) => {
    const classes = useStyles();
    const isMobile = useIsMobile();
    const { t } = useTranslation();

    const formula: { nutrient: string; value: number | null }[] = [
        { nutrient: nutrients.n, value: n ? n : ZERO },
        { nutrient: nutrients.p, value: p ? p : ZERO },
        { nutrient: nutrients.k, value: k ? k : ZERO },
    ];
    const percent = missingPercentage ? missingPercentage : ZERO;
    const renderMobileContent = () => {
        return formula.map((i, index) => {
            return (
                <div key={index}>
                    <span>{i.nutrient}</span>
                    <span className={classes.mobile_largeFont}>{i.value}</span>
                </div>
            );
        });
    };
    const renderContent = () => {
        return formula.map((i, index) => {
            return (
                <div key={index}>
                    <span>{i.nutrient}</span>
                    <span className={classes.largeFont}>{i.value}</span>
                </div>
            );
        });
    };
    if (isMobile) {
        return (
            <div className={classes.mobile_container}>
                <div className={classes.mobile_box}>
                    {percent !== ZERO && (
                        <div className={classes.mobile_topMessage}>
                            <span className={classes.spanWithMarginRight}>
                                {percent > ZERO ? t("pageStep5.updateCard.errorMessage.missingWord") : t("pageStep5.updateCard.errorMessage.extraWord")}
                            </span>
                            <span> {Math.abs(percent)}</span>
                            <span className={classes.normalWight}>{t("pageStep5.updateCard.errorMessage.rightPart")}</span>
                        </div>
                    )}
                    <div className={classes.mobile_leftText}>
                        <span>{t("pageStep5.updateCard.leftSpan")}</span>
                    </div>
                    <div className={classes.mobile_centerText}>{renderMobileContent()}</div>
                </div>
            </div>
        );
    }

    return (
        <div className={classes.container}>
            <div className={classes.leftText}>
                <span>{t("pageStep5.updateCard.leftSpan")}</span>
            </div>
            <div className={classes.centerText}>{renderContent()}</div>
            {percent !== ZERO && (
                <div className={classes.rightMessage}>
                    <span className={classes.spanWithMarginRight}>
                        {percent > ZERO ? t("pageStep5.updateCard.errorMessage.missingWord") : t("pageStep5.updateCard.errorMessage.extraWord")}
                    </span>
                    <span className={classes.normalWight}> {Math.abs(percent)}</span>
                    <span className={classes.normalWight}>{t("pageStep5.updateCard.errorMessage.rightPart")}</span>
                </div>
            )}
        </div>
    );
};

export default FmCalculatedNpkCard;
